exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n    #btn-keluar {\n      visibility: hidden;\n    }\n\n    #btn-print {\n        visibility: hidden;\n      }\n  \n    \n  }", ""]);

// exports
